// src/pages/NewsPage.jsx
import { useEffect, useState } from "react";
import BannerRecent from "../components/BannerRecent";
import WeeklyNews from "../components/WeeklyNews";
import NewsletterSubscribe from "../components/NewsletterSubscribe";
import SidebarTabs from "../components/SidebarTabs";
import NewsForm from "../components/NewsForm";
import SEO from "../components/SEO";

import {
  loadNewsData,
  saveNewsData,
  deletePost,
} from "../components/utils/storage";

import arrow from "../assets/images/right-arrow.webp";
import { CiCalendar } from "react-icons/ci";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import "../assets/css/News.css";
import Modal from "../components/Modal";

const NewsPage = ({ language }) => {
  /* ---------------- STATE ---------------- */
  const [tab, setTab] = useState("news");
  const [db, setDb] = useState(loadNewsData());
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [email, setEmail] = useState("");
  const isAdmin = localStorage.getItem("isAdmin") === "true";
 const navigate = useNavigate();
  /* ---------------- LANGUAGE DATA ---------------- */
  const langData = db[language] || { news: [], insights: [], popular: [] };

  /* ---------------- SAVE STORAGE WHEN DB CHANGES ---------------- */
  const [searchParams] = useSearchParams();

useEffect(() => {
  const currentTab = searchParams.get("tab") || "news";
  setTab(currentTab);
}, [searchParams]);


useEffect(() => {
  const currentTab = searchParams.get("tab") || "news";
  setTab(currentTab);
}, [useSearchParams]);
  /* ---------------- ADD / UPDATE HANDLER ---------------- */
  const handleAdd = (updatedDb) => {
    setDb({ ...updatedDb }); // ensure rerender
    setEditItem(null);
    setShowModal(false);
  };

  /* ---------------- DELETE POST ---------------- */
  const handleDelete = (id, category) => {
    if (!window.confirm("Delete this post?")) return;

    const updatedDb = deletePost(id, category, language);
    setDb({ ...updatedDb });
  };

  /* ---------------- LOCK SCROLL WHEN MODAL OPEN ---------------- */
 useEffect(() => {
  if (showModal) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
}, [showModal]);


  /* ---------------- BANNER POST ---------------- */
  const bannerPost = langData.news[0] || null;

  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
  }, [language]);

  // console.log(langData);

  const sub = (e) => {
    e.preventDefault();

    const googleScriptUrl = "https://script.google.com/macros/s/AKfycbx6273Y6inBParKKb8apdHsK3aqNm6VetI8aQge4LI4s6bS9OHYGg7vhfcanGeOk1acCA/exec"; // Replace this with your actual URL

    const data = {
      email: email, // Make sure this matches the header in your Google Sheet
    };

    fetch(googleScriptUrl, {
      method: "POST",
      body: new URLSearchParams(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.result === "success") {
          alert("Successfully subscribed!");
        } else {
          alert("Error subscribing: " + data.error);
        }
      })
      .catch((error) => {
        alert("Error: " + error);
      });
  };


  return (
    <>
      <SEO
        title="News & Insights | CaptainX Sports Technology"
        titleAr="الأخبار والتحليلات | كابتن اكس لتكنولوجيا الرياضة"
        description="Stay updated with the latest news, insights, and innovations in AI-powered sports technology from CaptainX."
        descriptionAr="ابق على اطلاع بآخر الأخبار والتحليلات والابتكارات في تكنولوجيا الرياضة المدعومة بالذكاء الاصطناعي من كابتن اكس."
        path="/news"
        language={language}
      />

      {/* ---------------- TOP SECTION ---------------- */}
      <section className="tab py-4">
        <div className="tab-con">
          <div className="container">
            <div className="d-flex justify-content-between align-items-center mb-5 tab-con-text">
              <h6>{language === "ar" ? "الأخبار والتحليلات" : "News & Insights"}</h6>

              <div className="d-flex align-items-center gap-2">
                {/* NEWS BUTTON */}
                <button
                  className={tab === "news" ? "explore-btn space-btn" : "explore-btn-border"}
                  onClick={() => navigate(`/news?tab=news`)}
                >
                  {language === "ar" ? "الأخبار" : "News"}
                </button>

                {/* INSIGHTS BUTTON */}
                <button
                  className={tab === "insights" ? "explore-btn space-btn" : "explore-btn-border"}
                   onClick={() => navigate(`/news?tab=insights`)}
                >
                  {language === "ar" ? "التحليلات" : "Insights"}
                </button>

                {/* ADMIN CREATE BUTTON */}
              {isAdmin && (
  <>
    {/* Desktop button */}
    
    <button
      className="explore-btn-border d-none d-md-inline-block"
      onClick={() => {
        setEditItem(null);
        setShowModal(true);
      }}
    >
      + {language === "ar" ? "إنشاء منشور" : "Create Post"}
    </button>

    {/* Mobile floating button */}
    <button
      className="fab-btns d-md-none"
      onClick={() => {
        setEditItem(null);
        setShowModal(true);
      }}
      aria-label="Create Post"
    >
      +
    </button>
  </>
)}

              </div>
            </div>
          </div>
        </div>

        {/* ---------------- MODAL ---------------- */}
{showModal && (
  <Modal
    onClose={() => setShowModal(false)}
    language={language}
  >
    <NewsForm
      language={language}
      onAdd={handleAdd}
      editItem={editItem}
      setEditItem={setEditItem}
    />
  </Modal>
)}



        {/* ---------------- BANNER SECTION ---------------- */}
        {tab === "news" ? (
          <div className="container">
            <div className="banner-sec">
              <BannerRecent post={bannerPost} language={language} />
            </div>
          </div>
        ) : (
          /* INSIGHTS BANNER LIST */
          <div className="container">
            <div className="row mt-3 banner-sec">
              <h5 className="card-title mb-2">
                {language === "ar" ? "التحليلات" : "Insights"}
              </h5>

              {langData.insights.slice(0, 3).map((ins) => (
                <div className="col-md-4 mb-3" key={ins.id}>
                  <Link to={`/insights/${language}/${ins.id}`}
                    style={{ textDecoration: "none", color: "inherit" }}>

                    <div className="card h-100 shadow-sm">
                      <img
                        src={ins.img}
                        className="card-img-top"
                        alt=""
                        style={{ height: 250, objectFit: "cover" }}
                      />

                      <div className="card-body">
                        <h6 className="card-title">
                          {typeof ins.title === "object" ? ins.title[language] : ins.title}
                        </h6>

                        <div className="text-muted small mb-1 mt-3 news-time">
                          <CiCalendar className="me-1" /> {ins.date}
                        </div>

                        <p className="text-muted">
                          {typeof ins.desc === "object" ? ins.desc[language] : ins.desc}
                        </p>
                      </div>
                    </div>
                  </Link>

                  {/* ADMIN Buttons */}
                  {isAdmin && (
                    <div className="d-flex gap-2 mt-2 relative">
                      <button
                        className="news-read-btn"
                        onClick={() => {
                          setEditItem(ins);
                          setShowModal(true);
                        }}
                      >
                        {language === "ar" ? "تعديل" : "Edit"}
                      </button>

                      <button
                        className="news-read-btn"
                        onClick={() => handleDelete(ins.id, "insights")}
                      >
                        {language === "ar" ? "حذف" : "Delete"}
                      </button>
                    </div>
                  )}
                </div>
              ))}

            </div>
          </div>
        )}
      </section>

      {/* ---------------- MAIN CONTENT ---------------- */}
      {tab === "news" ? (
        <div className="container py-4">
          <div className="row">
            {/* LEFT — WEEKLY NEWS */}
            <div className="col-md-8">
              <WeeklyNews
                language={language}
                items={langData.news}
                isAdmin={isAdmin}
                onEdit={(item) => {
                  setEditItem(item);
                  setShowModal(true);
                }}
                onDelete={(id) => handleDelete(id, "news")}
              />
            </div>

            {/* RIGHT — SIDEBAR */}
            <div className="col-md-4">
              <NewsletterSubscribe language={language} />

              <h5 className="mt-4 mb-2 card-title">
                {language === "ar" ? "الأخبار الشائعة" : "Popular News"}
              </h5>

              {langData.popular?.map((p) => (
                <div className="cards-d mb-3" key={p.id}>
                  <img src={p.img} className="card-img-top" alt="" />

                  <div className="card-body">
                    <div className="popular-category">{p.category}</div>

                    <h6 className="card-title">
                      {typeof p.title === "object" ? p.title[language] : p.title}
                    </h6>

                    <div className="text-muted small news-time">
                      <CiCalendar className="me-1" /> {p.date}
                    </div>

                    {isAdmin && (
                      <button
                        className="btn btn-sm btn-danger mt-2"
                        onClick={() => handleDelete(p.id, "popular")}
                      >
                        {language === "ar" ? "حذف" : "Delete"}
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        /* ------------ INSIGHTS MODE ------------ */
        <div className="container py-4">
          <div className="row mt-4">
            <div className="col-md-6">
              <SidebarTabs
                latest={langData.news.slice(0, 6)}
                featured={langData.news.filter((n) => n.featured)}
                language={language}
                isAdmin={isAdmin}
                onEdit={(i) => {
                  setEditItem(i);
                  setShowModal(true);
                }}
                onDelete={handleDelete}
              />
            </div>

            <div className="col-md-6"></div>
          </div>
        </div>
      )}

      {/* ---------------- CTA SECTION ---------------- */}
      <section className="cta cta-img">
        <div className="container">
          <center>
            <div className="cen-sec-con">
              <h2 className="sec-title text-center block-view">
                {language === "ar"
                  ? "لا تفوت أهم الأخبار والتحليلات"
                  : "Don't miss out the important news & Insights"}
              </h2>
              <form onSubmit={sub}>
                <input
                  placeholder={language === "ar" ? "أدخل بريدك الإلكتروني" : "Enter Your Mail ID"}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="newsletter-form mb-2"
                  required
                />

                
                  <button className="explore-btn cta-btn my-4 py-2 gap-3 block-view">
                    {language === "ar" ? "اشترك الآن" : "Subscribe Now"}
                    <img src={arrow} alt="arrow" className="rt-btn" />
                  </button>
                
              </form>
            </div>
          </center>
        </div>
      </section>
    </>
  );
};

export default NewsPage;
